import { DtoRequestAddchgsPostReq } from "./abst/DtoRequestAddchgsPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestAddchgsPostReqImple extends DtoRequestAddchgsPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
